import { Component, Input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { LogElement } from '@models/order';
import { OrderLogDialogComponent } from '@components/admin/order/order-log-dialog/order-log-dialog.component';

@Component({
  selector: 'app-last-editor-field',
  templateUrl: './last-editor-field.component.html',
  styleUrls: ['./last-editor-field.component.css'],
  providers: [DatePipe],
})
export class LastEditorFieldComponent {
  @Input() orderForm: FormGroup;

  constructor(private datePipe: DatePipe, private dialog: MatDialog) {}

  get sortedLogs(): LogElement[] {
    const logs = this.orderForm?.value?.log;
    if (!logs?.length) {
      return [];
    }
    return logs
      .slice()
      .sort(
        (a, b) =>
          new Date(b.date ?? 0).getTime() - new Date(a.date ?? 0).getTime()
      );
  }

  get latestLog(): LogElement | null {
    return this.sortedLogs[0] ?? null;
  }

  get displayInitials(): string {
    if (this.latestLog?.initials) {
      return this.latestLog.initials;
    }
    return this.sortedLogs.find((log) => log.initials)?.initials ?? '';
  }

  get displayValue(): string {
    if (!this.hasLogs) {
      return '';
    }
    const date = this.datePipe.transform(this.latestLog?.date, 'M/d/yy');
    const time = this.datePipe.transform(this.latestLog?.date, 'h:mm a');
    if (date && time) {
      return `${this.displayInitials} – ${date} ${time}`;
    }
    return date ? `${this.displayInitials} – ${date}` : this.displayInitials;
  }

  get hasLogs(): boolean {
    return this.sortedLogs.length > 0;
  }

  openLog(): void {
    if (!this.hasLogs) {
      return;
    }
    const value = this.orderForm?.value || {};
    const patient = value.patient;
    const patientId =
      (typeof patient === 'object' && patient?._id) || patient || null;
    this.dialog.open(OrderLogDialogComponent, {
      width: '560px',
      autoFocus: false,
      panelClass: 'order-log-dialog-panel',
      data: {
        logs: value.log || [],
        invoiceNumber: value.invoiceNumber,
        orderId: value._id,
        patientId,
      },
    });
  }
}
